import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';

// Helpers
import { getURLSegment, toggleDrawer } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';

// Components
import ExamDetails from '../Modules/ExamDetails';
import * as icons from '../Icons/Icons';
import Drawer from '../Drawer/Drawer';

const ChooseExam = observer(class ChooseExam extends React.Component {
  constructor() {
    super();
    this.initSchedule = this.initSchedule.bind(this);
    this.setProctorTypes = this.setProctorTypes.bind(this);
  }

  componentWillMount() {
    this.state = {
      proctorGroup: null,
      status: 'Needs Proctor'
    }

    // Get all proctor types so we can determine what type this group is
    this.props.store.SessionStore.getProctorTypes();

    // Get proctor group sid from url
    const proctorGroupSid = getURLSegment(this, 3);

    // Get student exams
    this.props.store.StudentStore.getStudentExams(true);

    // Get proctor group
    this.props.store.StudentStore.getProctorGroup(proctorGroupSid, this);

    // Get the current time from the server
    this.props.store.SessionStore.getCurrentTime();
  }

  // Output the correct module
  proctorTypeModule(thisType) {
    const { SessionStore } = this.props.store;
    let module = '';

    // If this group only has one type
    if(thisType.length === 1) {
      // Loop through parent categories
      SessionStore.proctorTypeList.map(
        (key, i) => {
          return (
            // Loop through subcategories and this proctor type category
            key.subCategories.filter(function(obj){
              return obj.sid === thisType[0]
            }).map(
              (subCategory, i) => {
                module = subCategory.module;
                return module;
              }
            )
          )
        }
      )
    }

    return module;
  }

  renderButton(module, proctorTypes, groupSid, proctorLocationSid, buttonText, examSid, sessionSid, configurationSid, exam) {
    const { translation } = this.props;

    // Figure out which button to show
    switch (module) {
      case 'bvirtual-attended':
      case 'online-attended':
        return (
          <button
            className="btn btn--action btn--icn-right"
            onClick={(e) => {this.initSchedule(e, 'ScheduleOnline', proctorLocationSid, sessionSid, examSid, exam)}}
            data-location={proctorLocationSid}
          >
            {translation.button}
            <icons.iconCircleRight className="icon" />
          </button>
        )

      case 'instructor':
        return (
          <button
            className="btn btn--action btn--icn-right"
            onClick={(e) => {this.initSchedule(e, 'ScheduleInstructor', proctorLocationSid, sessionSid, examSid, exam)}}
          >
            {translation.button}
            <icons.iconCircleRight className="icon" />
          </button>
        )

      case 'vtc':
        return (
          <button
            className="btn btn--action btn--icn-right"
            onClick={(e) => {this.initSchedule(e, 'ScheduleVTC', proctorLocationSid, sessionSid, examSid, exam)}}
          >
            {translation.button}
            <icons.iconCircleRight className="icon" />
          </button>
        )

      default:
        return (
          <Link
            className="btn btn--action btn--icn-right"
            to={`schedule-session/exam/${examSid}/session/${sessionSid}/configuration/${configurationSid}/search/group/${groupSid}`}
            onClick={() => {this.setProctorTypes(proctorTypes)}}
          >
            {translation.button}
            <icons.iconCircleRight className="icon" />
          </Link>
        );
    }
  }

  initSchedule(e, type, proctorLocationSid, sessionSid, examSid, exam) {
    this.props.store.ExamStore.exam = exam;
    this.props.store.ExamStore.examSession = exam.examSession;

    this.setState({
      proctorLocationSid
    });

    if(sessionSid) {
      this.setState({
        sessionSid
      });
    }

    if(examSid) {
      this.setState({
        examSid
      });
    }

    toggleDrawer(e, this, type);

    this.props.store.ProctorStore.proctorLocationSid = proctorLocationSid;
  }

  setProctorTypes(proctorTypes) {
    this.props.store.ProctorStore.proctorCategories = proctorTypes;
  }

  // Check if any of the proctor types in this group
  // are allowed by the exam session configuration
  validProctorType(exam, proctorTypes) {
    let valid = false;
    const sessionProctorTypes = exam.examSession.examConfiguration.proctorTypes;

    // Loop through the session configuration’s proctor types
    // and return true if any of them are in the proctor group’s types
    for(let i = 0; i < sessionProctorTypes.length; i++) {
      if(proctorTypes.indexOf(sessionProctorTypes[i]) >= 0) {
        valid = true;
      }
    }

    return valid;
  }

  // Check if scheduling is closed
  schedulingClosed(exam) {
    let closed = false;

    const configuration = exam.examSession.examConfiguration;
    const now = moment(this.props.store.SessionStore.currentTime);
    let scheduleCloseDate = configuration.scheduleCloseDate;

    if(moment(scheduleCloseDate).format('M-D-YYYY') === '1-1-2070') {
      // If there’s no scheduling window set, use the exam close date
      scheduleCloseDate = configuration.examCloseDate;
    }

    const closeDate = moment(scheduleCloseDate);
    const closeDiff = moment.duration(closeDate.diff(now)).asHours();

    if(closeDiff < 0) {
      closed = true;
    }

    return closed;
  }

  // Check if scheduling has opened
  schedulingOpen(exam) {
    let open = true;

    const configuration = exam.examSession.examConfiguration;
    const now = moment(this.props.store.SessionStore.currentTime);

    let scheduleOpenDate = configuration.scheduleOpenDate;

    const openDate = moment(scheduleOpenDate);
    const openDiff = moment.duration(openDate.diff(now)).asHours();

    if(openDiff >= 0) {
      open = false;
    }

    return open;
  }

  renderResults() {
    const { translation } = this.props;
    const { SessionStore, StudentStore } = this.props.store;

    if(!SessionStore.loading) {
      if(StudentStore.exams.length === 0) {
        return (
          <div className="no-results">
            {translation.no_results}
            <span className="no-results__sub">{translation.no_results_sub}</span>
          </div>
        )
      } else if(StudentStore.exams.length > 0 && this.state.proctorGroup) {
        return (
          <div className="wrap wrap--brief">
            <ul className="block-list">
              {StudentStore.exams.map(
                (key, i) => {
                  if(
                    this.validProctorType(key, this.state.proctorGroup.proctorTypes) &&
                    !this.schedulingClosed(key) &&
                    key.examSession.status.toLowerCase() === 'needs proctor'
                  ) {
                    return (
                      <li key={i} className="block-list__block">
                        <h2 className="block-list__title">{key.title}</h2>

                        <ExamDetails scheduleWindow={true} exam={key} compact={true} {...this.props} />

                        {this.schedulingOpen(key) &&
                          this.renderButton(
                            this.proctorTypeModule(this.state.proctorGroup.proctorTypes),
                            this.state.proctorGroup.proctorTypes,
                            this.state.proctorGroup.sid,
                            this.state.proctorGroup.proctorLocationSid,
                            translation.buttonText,
                            key.sid,
                            key.examSession.sid,
                            key.configuration.sid,
                            key
                          )
                        }

                        {!this.schedulingOpen(key) &&
                          <p className="note">{translation.not_open}</p>
                        }
                      </li>
                    )
                  }

                  return null;
                }
              )}
            </ul>
          </div>
        )
      }
    }

    return null;
  }

  render() {
    const { translation } = this.props;

    return (
      <main tabIndex="0" id="main-content" className="page">
        <header className="page__header">
          <div className="wrap">
            <h1 className="page__title">{translation.page_title}</h1>
          </div>
        </header>

        {this.renderResults()}

        <Drawer
          content={this.state.drawerContent}
          isOpen={this.state.drawerOpen}
          parent={this}
          proctorLocationSid={this.state.proctorLocationSid}
          examSid={this.state.examSid}
          sessionSid={this.state.sessionSid}
          status={this.state.status}
          skipUrl={true}
          {...this.props}
        />
      </main>
    )
  }
})

export default translate('ChooseExam')(ChooseExam);



// WEBPACK FOOTER //
// ./src/app/components/StudentDashboard/ChooseExam.js